import orgHttps from '../init/orgHttps';

export async function orgCreateAccommodation(data) {
    const result = await orgHttps.post(`org/accommodation`, data);
    return result;
}

export async function orgUpdateAccommodation(id, data) {
    const result = await orgHttps.put(`org/accommodation/${id}`, data);
    return result;
}

//fetch every accommodation belonging to the logged-in organizer
export async function orgGetAccommodations() {
    const result = await orgHttps.get(`org/accommodation/organizer`);
    return result;
}

//fetch a single accommodation by id (used to open the edit form)
export async function orgGetAccommodationById(id) {
    const result = await orgHttps.get(`org/accommodation/${id}`);
    return result;
}

export async function orgDeleteAccommodation(id) {
    const result = await orgHttps.delete(`org/accommodation/${id}`);
    return result;
}
